import template from './cart-summary-dialog.html';
export var CartSummaryDialogComponent = {
    template: template,
    bindings: {
        addingToCart: '<',
        item: '<',
        response: '<',
        quantity: '<',
        limitedStock: '<'
    },
    controller: /** @class */ (function () {
        function CartSummaryDialogComponent($mdDialog, CartService) {
            'ngInject';
            this.$mdDialog = $mdDialog;
            this.CartService = CartService;
        }
        CartSummaryDialogComponent.prototype.$onInit = function () {
            this.freeShipping = 250;
            this.cart = null;
            this.removingItem = null;
        };
        CartSummaryDialogComponent.prototype.$onChanges = function (changes) {
            if (changes.item) {
                this.item = Object.assign({}, this.item, { totalPrice: 0, quantity: 0, onHandQuantity: 0, isOnVendorBackOrder: false });
            }
            if (changes.response) {
                this.response = Object.assign({}, this.response);
                if (this.response.response) {
                    this.refreshItemAndCart(this.response.response);
                }
            }
        };
        CartSummaryDialogComponent.prototype.onClose = function () {
            this.$mdDialog.hide();
        };
        CartSummaryDialogComponent.prototype.refreshItemAndCart = function (cart) {
            this.cart = Object.assign({}, cart);
            if (this.cart.items && this.cart.items.length) {
                var cartItem = this.CartService.getItemFromCart(this.item.itemCode, this.cart.items);
                this.item = Object.assign({}, this.item, { totalPrice: cartItem.totalPrice, quantity: cartItem.quantity });
                if (this.item.inventory && this.item.inventory.length) {
                    var inventory = this.CartService.getDefaultInventory(this.item.inventory);
                    this.item.onHandQuantity = inventory.stock;
                    this.item.isOnVendorBackOrder = inventory.vendorBackOrder;
                }
            }
        };
        CartSummaryDialogComponent.prototype.updateQuantity = function (_a) {
            var _this = this;
            var item = _a.item;
            if (!item)
                return;
            this.updatingQuantity = this.CartService.itemQuantity(item.itemCode, item.quantity)
                .then(function (response) {
                if (response) {
                    _this.refreshItemAndCart(response.response);
                }
            })
                .finally(function () {
                _this.updatingQuantity = false;
            });
        };
        CartSummaryDialogComponent.prototype.removeItem = function (_a) {
            var _this = this;
            var itemCode = _a.itemCode;
            if (!itemCode)
                return;
            this.removingItem = this.CartService.removeItem(itemCode)
                .then(function (response) {
                _this.itemRemoved = true;
                _this.cart = Object.assign({}, response.data.response);
            })
                .finally(function () {
                _this.removingItem = null;
            });
        };
        return CartSummaryDialogComponent;
    }())
};
//# sourceMappingURL=cart-summary-dialog.component.js.map